import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Sandbox16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.75 2.25H9.5V0.75H6.5V2.25H7.25V6H5.71423L6.02673 7.25L2.27464 7.25L3.9413 4.25H6V2.75H3.7942C3.34024 2.75 2.92197 2.99612 2.7015 3.39295L0.407303 7.52251C0.304138 7.70821 0.25 7.91713 0.25 8.12956V13C0.25 13.6904 0.809643 14.25 1.5 14.25H14.5C15.1904 14.25 15.75 13.6904 15.75 13V8.12956C15.75 7.91713 15.6959 7.70821 15.5927 7.52251L13.2985 3.39295C13.078 2.99611 12.6598 2.75 12.2058 2.75H10V4.25H12.0587L13.7254 7.25L9.97316 7.25L10.2857 6H8.75V2.25ZM1.75 8.75L14.25 8.75V12.75H1.75V8.75Z'
      fill='currentColor'
    />
  </Svg>
);

Sandbox16.displayName = 'Sandbox16';
export default Sandbox16;
